<template>
  <resource-search @delete="() => this.$emit('delete')" @input="id => this.$emit('input', id)" module="extras" :show-delete="showDelete" :error-feed="errorFeed" :error-key="errorKey" :wait-for-input="waitForInput" :fetch-params="extraFetchParams" v-model="value">
    <template #popover-list="{ result }">
        <p class="font-weight-bold mb-0  w-100-m-1">{{ result.name }}</p>
        <p class="text-muted text-truncate mb-0 w-100-m-1"><small>£{{ result.price }}</small></p>
    </template>

    <template #selected="{ selected }">
      <b-row>
          <b-col cols="12">
            <p class="font-weight-bold mb-0  w-100-m-1">{{ selected.name }}</p>
            <p class="text-muted mb-0">£{{ useDisplayPrice ? displayPrice : selected.price }}</p>
          </b-col>
      </b-row>
    </template>

    <template #selected-inline-form-area>
      <slot name="selected-inline-form-area" />
    </template>

    <template #selected-form-area>
      <slot name="form-area" />
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from './ResourceSearch.vue'

export default {
  components: { ResourceSearch },
  props: {
    useDisplayPrice: {
      type: Boolean,
      default: false,
    },
    displayPrice: {
      type: [Number, String],
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    waitForInput: {
      type: Boolean,
      default: true,
    },
    errorFeed: Object,
    errorKey: String,
    type: String,
    value: Object,
  },
  computed: {
    extraFetchParams() {
      if (this.type) {
        return { type: this.type };
      }

      return {};
    }
  }
}
</script>

<style>

</style>